function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("polyline", {
  points: "20 6 9 17 4 12"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#0094dd",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "arcs"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/check.9e2db162.svg";
export { SvgComponent as ReactComponent };